import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function JoinLeague() {
  const [code, setCode] = useState('')
  const [teamName, setTeamName] = useState('')
  const [err, setErr] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)
  const nav = useNavigate()

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setBusy(true)
    setErr(null)
    const { data, error } = await supabase.rpc('join_league', {
      p_code: code.trim().toUpperCase(),
      p_team_name: teamName || 'My Team',
    })
    setBusy(false)
    if (error) return setErr(error.message)
    nav(`/app/l/${(data as any).league_id}`)
  }

  return (
    <div className="page">
      <header className="topbar">
        <Link className="wordmark" to="/app">GRIDLOCK</Link>
      </header>
      <main className="container narrow">
        <h1>Join a league</h1>
        <form className="card form" onSubmit={submit}>
          <label>
            Join code
            <input
              value={code}
              onChange={(e) => setCode(e.target.value.toUpperCase())}
              placeholder="A1B2C3"
              maxLength={6}
              required
            />
          </label>
          <label>
            Your team name
            <input value={teamName} onChange={(e) => setTeamName(e.target.value)} />
          </label>
          <button className="btn btn-primary full" disabled={busy}>
            {busy ? 'Joining…' : 'Join'}
          </button>
          {err && <p className="error">{err}</p>}
        </form>
      </main>
    </div>
  )
}
